import serviceType from 'constants/serviceType';
import axiosClient from './aixosClient';
import { AxiosResponse } from 'axios';
import { BaseResponse } from 'models/baseResponse';
import { CreateBankOrder3rdPayload } from 'models/bankModel';
import { VNPayDeposit, WithdrawApplyPayload, wPayDeposit } from 'models/walletModel';

const walletApi = {
    depositInit(payload: { action?: string; origin?: string }): Promise<AxiosResponse<BaseResponse<any>>> {
        payload.action = 'depositInit';
        payload.origin = window.location.origin;
        return axiosClient.post(serviceType.USER_SERVICE, payload);
    },
    getBankDeposit3rd(bankCode: string): Promise<AxiosResponse<BaseResponse<any>>> {
        let payload: any = {};
        payload['action'] = `${bankCode}`;
        return axiosClient.post(serviceType.PAY_SERVICE, payload);
    },
    createOrderBank3rd(payload: CreateBankOrder3rdPayload): Promise<AxiosResponse<BaseResponse<any>>> {
        return axiosClient.post(serviceType.PAY_SERVICE, payload);
    },

    withdrawal(payload: { action?: string }): Promise<AxiosResponse<BaseResponse<any>>> {
        payload.action = 'withdrawal';
        return axiosClient.post(serviceType.USER_SERVICE, payload);
    },
    withdrawalApply(payload: WithdrawApplyPayload): Promise<AxiosResponse<BaseResponse<any>>> {
        payload.action = 'withdrawal_apply';
        return axiosClient.post(serviceType.USER_SERVICE, payload);
    },
    orderWinPay(payload: wPayDeposit): Promise<AxiosResponse<BaseResponse<any>>> {
        payload.action = 'wPayDeposit_deposit';
        return axiosClient.post(serviceType.PAY_SERVICE, payload);
    },

    vnPayDeposit(payload: VNPayDeposit): Promise<AxiosResponse<BaseResponse<any>>> {
        payload.action = "vnPayDeposit_deposit";
        return axiosClient.post(serviceType.PAY_SERVICE, payload);
    },

    vnPayQrDepositListBankTransfer(payload: any): Promise<AxiosResponse<BaseResponse<any>>> {
        payload.action = 'vnPayDeposit_listBankQR';
        return axiosClient.post(serviceType.PAY_SERVICE, payload);
    },

    vnPayDepositListBankTransfer(payload: any): Promise<AxiosResponse<BaseResponse<any>>> {
        payload.action = 'vnPayDeposit_listBankTransfer';
        return axiosClient.post(serviceType.PAY_SERVICE, payload);
    },

    getListBankWinPay(payload: any): Promise<AxiosResponse<BaseResponse<any>>> {
        payload.action = 'wPayDeposit_listChannelTransfer';
        return axiosClient.post(serviceType.PAY_SERVICE, payload);
    },

    //v8 pay
    v8BankList(payload: any): Promise<AxiosResponse<BaseResponse<any>>> {
        payload.action = 'v8PayDeposit_listBank';
        return axiosClient.post(serviceType.PAY_SERVICE, payload);
    },

    v8Order(payload: any): Promise<AxiosResponse<BaseResponse<any>>> {
        payload.action = 'v8PayDeposit_Deposit';
        return axiosClient.post(serviceType.PAY_SERVICE, payload);
    },

    // USDT Deposit APIs
    usdtGetProviders(payload: any = {}): Promise<AxiosResponse<BaseResponse<any>>> {
        payload.action = 'mfcPayDeposit_GetProviders';
        return axiosClient.post(serviceType.PAY_SERVICE, payload);
    },

    usdtGetRate(payload: { provider_code: string; coin_symbol: string; action?: string }): Promise<AxiosResponse<BaseResponse<any>>> {
        payload.action = 'mfcPayDeposit_GetRate';
        return axiosClient.post(serviceType.PAY_SERVICE, payload);
    },

    usdtCalculate(payload: { input_type: 'deposit' | 'withdraw'; fiat_amount: string }): Promise<AxiosResponse<BaseResponse<any>>> {
        (payload as any).action = 'mfcPayDeposit_Calculate';
        return axiosClient.post(serviceType.PAY_SERVICE, payload);
    },

    usdtGetWallet(payload: { provider_code: string; coinSymbol: string; action?: string }): Promise<AxiosResponse<BaseResponse<any>>> {
        payload.action = 'mfcPayDeposit_GetWallet';
        return axiosClient.post(serviceType.PAY_SERVICE, payload);
    },

    usdtCreateWallet(payload: { coinSymbol?: string } = {}): Promise<AxiosResponse<BaseResponse<any>>> {
        (payload as any).action = 'mfcPayDeposit_CreateWallet';
        (payload as any).flag = 'CreateWallet';
        return axiosClient.post(serviceType.PAY_SERVICE, payload);
    },

    usdtDeposit(payload: { coinSymbol: string; fiat_amount: string }): Promise<AxiosResponse<BaseResponse<any>>> {
        (payload as any).action = 'mfcPayDeposit_Deposit';
        (payload as any).redirect = false;
        return axiosClient.post(serviceType.PAY_SERVICE, payload);
    },

    // USDT Withdrawal APIs
    usdtAddWithdrawWallet(payload: { usdtAddress: string; checkpwd: string; coinSymbol: string }): Promise<AxiosResponse<BaseResponse<any>>> {
        (payload as any).action = 'personBankCard_addUsdtWallet';
        return axiosClient.post(serviceType.USER_SERVICE, payload);
    },

    usdtListWithdrawWallet(payload: { coinSymbol: string }): Promise<AxiosResponse<BaseResponse<any>>> {
        (payload as any).action = 'personBankCard_listUsdtWallet';
        return axiosClient.post(serviceType.USER_SERVICE, payload);
    },

    usdtWithdraw(payload: { wamount: string; usdtid: number; checkpwd: string }): Promise<AxiosResponse<BaseResponse<any>>> {
        (payload as any).action = 'withdrawal_apply';
        return axiosClient.post(serviceType.USER_SERVICE, payload);
    }
};
export default walletApi;
